export default [

     {
          path: '/risk-planning-strategy',
          name: 'RiskPlanningStrategy',
          component: () => import("@/views/Page/RiskPlanningStrategy/RiskPlanningStrategy.vue"),
          meta: {
               title: 'Risk Planning Strategy',
          },
     }
];